/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { InsuranceCardConfig } from 'src/config';

// Collection of insurance details for the insurance selection screen on the member form
const memberInsurance: InsuranceCardConfig[] = [];

export default memberInsurance;
